import { forwardRef } from 'preact/compat'
import { InputHTMLAttributes } from 'preact'
import SearchLogo from '../../../../../../../themes/custom/toybox/src/images/search--currentcolor.svg'

// We want to provide our own narrower/simpler definition of onSubmit than the
// InputHTMLAttributes type provides.
interface RaffleSearchInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'onSubmit'
> {
  submitButtonText?: string
  onSubmit?: (query: string) => void
}

export const RaffleSearchInput = forwardRef<
  HTMLInputElement,
  RaffleSearchInputProps
>(
  (
    {
      submitButtonText = 'Søg',
      placeholder = 'Hvad søger du?',
      id = 'q',
      name = 'q',
      value = '',
      onSubmit,
      ...inputProps
    },
    ref,
  ) => {
    return (
      <div className="raffle-search-input">
        <input
          ref={ref}
          type="text"
          placeholder={placeholder}
          id={id}
          name={name}
          value={value}
          {...inputProps}
        />
        <button type="submit" className="raffle-search-input__submit">
          <span className="raffle-search-input__submit-text">
            {submitButtonText}
          </span>
          <SearchLogo aria-hidden />
        </button>
      </div>
    )
  },
)

RaffleSearchInput.displayName = 'RaffleSearchInput'
